import { colaboratorsURL } from '.';
import { getAccessToken, onUnauthorized } from './auth';
import axios, { AxiosInstance } from 'axios';

export type Colaborator = {
  id: string;
  name: string;
  email: string;
  phone: string;
  isDeleted: boolean;
  invited: boolean;
};

export type ColaboratorWriteModel = Omit<Colaborator, 'id'>;

function getColaboratorApi(): AxiosInstance {
  const accessToken = getAccessToken();
  if (!accessToken) {
    onUnauthorized();
    throw new Error('Sessão expirada');
  }

  return axios.create({
    baseURL: colaboratorsURL,
    headers: { Authorization: `Bearer ${accessToken}` },
  });
}

export async function createColaborator(
  colaborator: ColaboratorWriteModel,
): Promise<Colaborator> {
  const api = getColaboratorApi();

  const res = await api.post('', colaborator);

  return res.data as Colaborator;
}
export async function updateColaborator(
  id: string,
  colaborator: ColaboratorWriteModel,
): Promise<Colaborator> {
  const api = getColaboratorApi();

  const res = await api.put(`/${id}`, colaborator);

  return res.data as Colaborator;
}

export async function inviteColaborator(id: string): Promise<Colaborator> {
  const api = getColaboratorApi();

  const res = await api.post(`/${id}/invite`);

  return res.data as Colaborator;
}
export async function getAllColaborators(): Promise<Colaborator[]> {
  const api = getColaboratorApi();

  const res = await api.get('');

  return res.data as Colaborator[];
}

export async function getColaboratorByID(id: string): Promise<Colaborator> {
  const api = getColaboratorApi();

  const res = await api.get(`/${id}`);

  return res.data as Colaborator;
}

export async function deleteColaborator(id: string): Promise<void> {
  const api = getColaboratorApi();

  await api.delete(`/${id}`);
}
